import { render, staticRenderFns } from "./scrmList.vue?vue&type=template&id=c3f19338&scoped=true&"
import script from "./scrmList.vue?vue&type=script&lang=js&"
export * from "./scrmList.vue?vue&type=script&lang=js&"
import style0 from "./scrmList.vue?vue&type=style&index=0&id=c3f19338&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c3f19338",
  null
  
)

export default component.exports